// extracted by mini-css-extract-plugin
export default {"root":"SegmentedControl_root__122X_","segment":"SegmentedControl_segment__3cLRY","white":"SegmentedControl_white__3yCa7","on":"SegmentedControl_on__3Elau"};